/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import styled, { keyframes } from 'styled-components';
import { Combobox } from '@veeam/components';

import type { ComboboxProps } from '../Combobox';

type ComboboxWithSpinnerProps<T, K> = Omit<ComboboxProps<T, K>, 'name'>;

const BUTTON_SELECTOR = 'button[data-selector-id="combobox-open-dropdown-action"]';
const SVG_SELECTOR = 'svg[data-selector-id="arrow-icon"]';
const SPINNER_SIZE = '16px';
const SPINNER_MARGIN = '-10px 0 0 -10px';
const SPINNER_BORDER = '2px solid rgb(0, 125, 182)';
const SPINNER_BORDER_RADIUS = '50%';
const SPINNER_ANIMATION_DURATION = '1.5s';

const spinAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const ComboboxWithSpinner = styled(Combobox)<ComboboxWithSpinnerProps<any, any>>`
    ${BUTTON_SELECTOR} ${SVG_SELECTOR} {
        display: ${props => props.isLoading ? 'none' : 'block'};
    }

    ${BUTTON_SELECTOR}:before {
        content: '';
        display: ${props => props.isLoading ? 'block' : 'none'};
        position: absolute;
        top: 50%;
        width: ${SPINNER_SIZE};
        height: ${SPINNER_SIZE};
        margin: ${SPINNER_MARGIN};
        border: ${SPINNER_BORDER};
        border-top-color: transparent;
        border-radius: ${SPINNER_BORDER_RADIUS};
        animation: ${spinAnimation} ${SPINNER_ANIMATION_DURATION} linear infinite;
    }
}`;
